/**
 *    Image collection
 *
 *    @tableofcontent
 *      1. Dependencies
 *      2. Functions
 *       2.1 Init
 *       2.2 Image collection
 *
 */


/**
 *     @section 1. Dependencies
 */

// import Constants from '../settings/_variables';
// import TweenMax from 'gsap/src/uncompressed/TweenMax';
// import TimelineMax from 'gsap/src/uncompressed/TimelineMax';
// import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';


/**
 *     @section 2. Functions
 */

export default {

    // @section 2.1 Init
    init() {
        // console.log('image collection loaded ...');

        this.imageCollection();

    },

    // @section 2.2 Image collection
    imageCollection() {
        // const controllercollection = new ScrollMagic.Controller();

        // // set width
        // $(`.${Constants.prefix}collection`).each(function(i,e){

        //     let collection = e,
        //         $collection = $(collection),
        //         collectionWrap = $collection.closest(`.${Constants.prefix}collection__wrap`)[0],
        //         collectionWidth = 0;

        //     $collection.find(`.${Constants.prefix}collection__item`).each(function(i,e){
        //         collectionWidth += $(e).width();
        //     });

        //     let horizontalSlide = new TimelineLite()
        //     // animate panels
        //         .to(collection, 1, {x: -Math.abs(collectionWidth)});

        //     // create scene to pin and link animation
        //     let scene = new ScrollMagic.Scene({
        //         triggerElement: collectionWrap,
        //         triggerHook: 'onCenter',
        //         duration: '300%',
        //         offset: 200 // half height of collection
        //     })
        //         .setPin(collectionWrap)
        //         .setTween(horizontalSlide)
        //         .addTo(controllercollection);

        //     // on resize
        //     $(window).resize(function() {

        //         // destroy and remove scene
        //         scene.destroy(true);
        //         scene.remove();

        //         // @todo: doppelten code zusammenführen
        //         let collection = e,
        //             $collection = $(e),
        //             collectionWrap = $collection.closest(`.${Constants.prefix}collection__wrap`)[0],
        //             collectionWidth = 0;

        //         $collection.find(`.${Constants.prefix}collection__item`).each(function(i,e){
        //             collectionWidth += $(e).width();
        //         });

        //         let horizontalSlide = new TimelineLite()
        //         // animate panels
        //             .to(collection, 1, {x: -Math.abs(collectionWidth)});

        //         // create scene to pin and link animation
        //         scene = new ScrollMagic.Scene({
        //             triggerElement: collectionWrap,
        //             triggerHook: 'onCenter',
        //             duration: '300%',
        //             offset: 200 // half height of collection
        //         })
        //             .setPin(collectionWrap)
        //             .setTween(horizontalSlide)
        //             .addTo(controllercollection);
        //     });
        // });

    }
};

// end of _image-collection.js
